module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_2.4cb6a3c7.png";